<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-nova-equipe')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-equipe')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-width="20%">
        <el-form-item label="Tipo" prop="type" class="is-required">
          <el-radio v-model="ruleForm.type" label="team">Equipe</el-radio>
          <el-radio v-model="ruleForm.type" label="fleet">Frota</el-radio>
        </el-form-item>
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input
              ref="code"
              :disabled="id !== ''"
              v-model="ruleForm.code"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('responsavel')" prop="owner">
          <UserList
            ref="owner"
            v-model="ruleForm.owner"
            :type="'1'"
            :current="ruleForm.owner"
            @selected="owner"
            :multiple="false"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-if="ruleForm.type === 'team'"
        :data="tableDrivers"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="name"
          :label="$t('motorista')"
        ></el-table-column>
      </el-table>
      <el-table
        v-else
        :data="tableFleet"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="team"
          :label="$t('equipe')"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { TeamService } from "@/services/umov/team.services";
import { i18n } from "@/plugin/i18n";
import UserList from "../../register/user/UserList.vue";

export default {
  name: "TeamAdd",
  data() {
    return {
      id: "",
      tableDrivers: [],
      tableFleet: [],
      ruleForm: {
        type: "team",
        name: "",
        code: "",
        owner: null,
      },
    };
  },
  methods: {
    owner(data) {
      this.ruleForm.owner = data;
    },
    back() {
      var vm = this;
      vm.$router.replace({ name: "team" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      TeamService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
          vm.ruleForm.owner = response.owner ? response.owner.id : "";
          vm.tableDrivers = response.drivers;
          console.log("response", response);
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          TeamService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("equipe-adicionada-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          TeamService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("equipe-atualizada-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
  components: { UserList },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
